
/// <amd-module name="Release/DeploymentsSection/DeploymentsTabProviderService" />
import React = require("react");
import { BuildResult, BuildStatus } from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";
import { IRunViewContributedTabProps } from 'Build/Run/RunViewContributedTab';
import { DeploymentsTabLauncher } from "Release/DeploymentsSection/DeploymentsTab";
import * as Resources from "Release/DeploymentsSection/Resources";
import { IBuildReleaseDefinitionProvider } from "Release/Helpers/BuildReleaseDefinitionProvider";
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { ITabService } from "VSS/Features/PlatformUI/ContributedTab";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssContributedTab } from "VSSUI/Tabs.Types";

export class DeploymentsTabProviderService extends VssService implements ITabService<IRunViewContributedTabProps> {

    private _releaseDefinitionProvider: IBuildReleaseDefinitionProvider;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._releaseDefinitionProvider = pageContext.getService<IBuildReleaseDefinitionProvider>("IBuildReleaseDefinitionProvider");
    }

    public getTabs(tabId: string, contextualData?: IRunViewContributedTabProps): IVssContributedTab[] | IReadonlyObservableArray<IVssContributedTab> {
        if (!!contextualData) {
            this._contextualData = contextualData;
            this._showTab();
            this._contextualData.notifyUpdated.subscribe(this._showTab);
        }
        return this._tabs;
    }

    public _serviceEnd(pageContext: IVssPageContext): void {
        this._contextualData.notifyUpdated.unsubscribe(this._showTab);
    }

    private _showTab = async () => {
        if (!this._contextualData) {
            return;
        }

        if (this._contextualData.status.value !== BuildStatus.Completed) {
            return;
        }

        if (this._tabs.value.length > 0) {
            return;
        }

        const projectId = this._contextualData.projectId.value;
        const buildClient = this.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");
        const build = await buildClient.getBuild(projectId, this._contextualData.runId.value);

        if (build.result !== BuildResult.Succeeded && build.result !== BuildResult.PartiallySucceeded) {
            return;
        }

        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        await contributionService.getContributionAsync("ms.vss-releaseManagement-web.deployments-tab-for-pipeline-loader");

        const releaseDefinitions = await this._releaseDefinitionProvider.getReleaseDefinitionsByBuild(projectId, this._contextualData.pipelineId.value);

        if (releaseDefinitions.length === 0) {
            return;
        }

        this._tab.render = () => <div>
            <DeploymentsTabLauncher build={build} />
        </div>;
        this._tabs.push(this._tab);
    }

    private _contextualData: IRunViewContributedTabProps;
    private _tabs = new ObservableArray<IVssContributedTab>();
    private _tab: IVssContributedTab = {
        id: "ms.vss-releaseManagement-web.deployments-tab",
        name: Resources.Releases,
        order: 3
    };
}


Services.add("deployments-tab-provider-service", { serviceFactory: DeploymentsTabProviderService });
